var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useTheme } from '@mui/material';
import { Box } from '@mui/material';
import * as Preact from 'preact';
import * as SingleSelect from './M_SingleSelectList';
import * as DrawerNavigation from './O_ProductDrawerNavigation';
import { isSmallScreen } from './domain/theme/breakpoints';
import { getDisplayName } from './utils/translationHelpers';
import { useTranslations } from './utils/TranslationsWrapper';
export var Component = function (p) {
    var t = useTranslations().t;
    var isSmall = isSmallScreen(useTheme());
    return (Preact.h(Box, { sx: __assign({ display: 'flex', flexDirection: 'column', backgroundColor: 'background.paper', height: isSmall ? 'calc(100% - 44px)' : '100%', width: '100%', borderRight: '1px solid rgba(224, 224, 224, 0.5)' }, p.sx), "data-testid": "property-selector-container" },
        Preact.h(DrawerNavigation.Component, { title: getDisplayName('furniture.option.', p.title, t), onCloseClick: p.onCloseClick, onBackClick: p.onBackClick }),
        Preact.h(Box, { flexGrow: "1", sx: { overflowY: 'auto' } },
            Preact.h(SingleSelect.Component, { options: p.propertyOptions.map(SingleSelect.Option.fromPropertyOption), selectedProperty: p.selectedProperty, onOptionClick: p.onOptionClick, reorderDimensions: p.reorderDimensions }))));
};
Component.displayName = 'PropertySelectorContainer';
